import { CLIENTES } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null,
    loadingDetalles: false
};

export default function clientesReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case CLIENTES.LISTAR:
            return {
                ...state,
                listado: Array.isArray(payload) ? payload : []
            };

        case CLIENTES.LIMPIAR:
            return {
                ...state,
                listado: []
            };

        case CLIENTES.DETALLES_CARGANDO:
            return {
                ...state,
                detalles: null,
                loadingDetalles: true
            };

        case CLIENTES.DETALLES:
            return {
                ...state,
                detalles: payload || null,
                loadingDetalles: false
            };

        case CLIENTES.LIMPIAR_DETALLES:
            return {
                ...state,
                detalles: null,
                loadingDetalles: false
            };

        case CLIENTES.ERROR:
            return {
                ...state,
                loadingDetalles: false
            };

        default:
            return state;
    }
}
